import { cn, isDefined } from "@/lib/utils";
import { resolvePluralsDays } from "@/service/text/plurals";

const formatTime = (time: number) => String(time).padStart(2, "0");

export const CountdownTimer = ({
  timeLeft,
  isActive,
  hideTime,
  variant = "default",
  className,
}: {
  timeLeft: {
    days?: number | null;
    hours: number;
    minutes: number;
    seconds: number;
  };
  isActive: boolean;
  hideTime?: boolean;
  // „practiceExam" = wygląd z projektu banera próbnego LEK-u: przygaszone dwukropki, a odliczanie
  // w dniach ma podpis „dni" obok pola (nie „5d" w środku). Czerwień tylko przy otwartej rundzie.
  variant?: "default" | "practiceExam";
  // klasy korzenia — na kolorowym tle podaje się tu kolor tekstu dla dwukropków i podpisu „dni"
  className?: string;
}) => {
  const { days, hours, minutes, seconds } = timeLeft;
  const isPracticeExam = "practiceExam" === variant;
  const shouldHideTime =
    hideTime !== undefined ? hideTime : isDefined(days) && days > 0;
  const timeStyles = cn(
    `text-foreground min-w-8 h-8 rounded-lg border bg-white p-1.5 text-sm font-medium tabular-nums flex items-center justify-center`,
    isActive && "text-rose-600",
    // alarmowa obwódka dopiero gdy runda jest otwarta (można dołączyć) — samo odliczanie
    // do startu zostaje neutralne
    isPracticeExam && isActive && "border-rose-300 text-rose-600",
  );
  // dwukropki i podpis „dni" biorą kolor z otoczenia (na banerze przekazujemy `text-white`)
  const separatorStyles = cn(isPracticeExam && "text-sm font-medium");

  return (
    <div className={cn("flex items-center gap-1", className)}>
      {isDefined(days) && days > 0 && (
        <>
          <div className={timeStyles}>{isPracticeExam ? days : `${days}d`}</div>
          {isPracticeExam && (
            <span className="text-sm font-medium">
              {/* resolvePluralsDays dokleja liczbę, a ta jest już w polu obok */}
              {resolvePluralsDays(days).split(" ")[1]}
            </span>
          )}
          {!shouldHideTime && <span className={separatorStyles}>:</span>}
        </>
      )}
      {!shouldHideTime && (
        <>
          <div className={timeStyles}>{formatTime(hours)}</div>
          <span className={separatorStyles}>:</span>
          <div className={timeStyles}>{formatTime(minutes)}</div>
          <span className={separatorStyles}>:</span>
          <div className={timeStyles}>{formatTime(seconds)}</div>
        </>
      )}
    </div>
  );
};
